/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsBorderAll: {
  name: 'border-all';
  data: string;
} = {
  name: 'border-all',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill-rule="evenodd" clip-rule="evenodd" d="M.5 2A1.5 1.5 0 0 1 2 .5h12A1.5 1.5 0 0 1 15.5 2v12a1.5 1.5 0 0 1-1.5 1.5H2A1.5 1.5 0 0 1 .5 14V2Zm1 6.5V14a.5.5 0 0 0 .5.5h5.5v-6h-6Zm6-1h-6V2a.5.5 0 0 1 .5-.5h5.5v6Zm1 1v6H14a.5.5 0 0 0 .5-.5V8.5h-6Zm6-1h-6v-6H14a.5.5 0 0 1 .5.5v5.5Z" fill="currentColor"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
